import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const VideosSection = ({ id }) => {
  const [videoPath, setVideoPath] = useState("");
  const fetchVideoData = async () => {
    try {
      const response = await corefetch(`Videos/GetVideosFetchDetails?id=${id}`);
      if (response && response.length > 0) {
        setVideoPath(response[0].videopath);
      } else {
        setVideoPath("");
        console.error("No video data found");
      }
    } catch (error) {
      setVideoPath("");
      console.error("Failed to fetch video data", error);
    }
  };
  useEffect(() => {
    fetchVideoData();
  }, []);

  if (!videoPath || videoPath == "") {
    return null;
  }

  return (
    <section className="wpo-video-section">
      <h2 className="hidden">Some video section</h2>
      <div className="container-fluid">
        <div className="video-wrap">
          {videoPath && (
            <video
              id="autoplayVideo"
              autoPlay
              muted
              loop
              style={{ width: "100%" }}
            >
              <source src={`${ImageURL}${videoPath}`} type="video/mp4" />
            </video>
          )}
        </div>
      </div>
    </section>
  );
};

export default VideosSection;
